// React
import { FunctionComponent } from "react";

// UI Library
import { Modal, Button } from "react-bootstrap";

// Local components
import VehicleIncidentsActionOption from "../VehicleIncidentsActionOption/VehicleIncidentsActionOption";

// Services and utilities
import VIS from "../../VehicleIncidentsService";

// Interfaces
import { I_IncidentAction, I_SafetyEvent, I_SafetyEventWithApprovalHistory } from "../../interfaces";

// Styles
import "./VehicleIncidentsChooseAction.css";

interface Props {
    incidentAction: I_IncidentAction;
}

// Modal for choosing an action on a vehicle safety event
const VehicleIncidentsChooseAction: FunctionComponent<Props> = (props) => {
    const { incidentAction } = props;

    // Destructure shared methods from the service
    const { setIncidentAction, isWithApprovalHistory, retrieveEventFromMap, isLastApprover } = VIS;

    // Get full event details based on the selected incident ID
    const event: I_SafetyEvent | I_SafetyEventWithApprovalHistory | null =
        retrieveEventFromMap(incidentAction.id || -1);

    if (!event) return null

    // Determine if the event is brand new (no approval history yet)
    const isNew = !isWithApprovalHistory(event);
    const isLast = isLastApprover(event)

    return (
        <div className="VehicleIncidentsChooseAction">
            <Modal
                id="vehicle-incidents-action-incident-choose-action-modal"
                show
                backdrop="static"
                keyboard
                centered
                className="VehicleIncidentsWorkflowModal"
                animation={false}
            >
                <Modal.Header>
                    <div className="VehicleIncidentsChooseActionHeader VehicleIncidentsWorkflowModalHeader">
                        {isNew ? "Choose a starting point" : "Take an action"}
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="VehicleIncidentsChooseActionModalBody">
                        {/* Always show Start Discipline */}
                        <VehicleIncidentsActionOption
                            callback={() =>
                                setIncidentAction({
                                    action: 2,
                                    id: incidentAction.id,
                                })
                            }
                            checked={false}
                            title="Start Discipline"
                            icon="gavel"
                        />

                        {/* Show only relevant option based on approver position */}
                        {!isLast ? (
                            <VehicleIncidentsActionOption
                                callback={() => {
                                    if (isNew) {
                                        setIncidentAction({
                                            action: 3,
                                            id: incidentAction.id,
                                        });
                                    } else {
                                        setIncidentAction({
                                            action: 4,
                                            id: incidentAction.id,
                                        });
                                    }
                                }}
                                checked={false}
                                title={isNew ? "Start Review Process" : "Forward to next reviewer"}
                                icon={isNew ? "article" : "arrow_forward"}
                            />
                        ) : (
                            <VehicleIncidentsActionOption
                                callback={() =>
                                    setIncidentAction({
                                        action: 5, // assuming 5 = Ignore
                                        id: incidentAction.id,
                                    })
                                }
                                checked={false}
                                title="Ignore Incident"
                                icon="visibility_off"
                            />
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="VehicleIncidentsChooseActionModalFooter">
                        <div className="VehicleIncidentsChooseActionModalFooterLeft" >
                            {/* Cancel action resets the incidentAction state */}
                            <Button
                                variant="secondary"
                                onClick={() =>
                                    setIncidentAction({ action: -1, id: -1 })
                                }
                            >
                                Cancel
                            </Button>
                        </div>
                        <div className="VehicleIncidentsChooseActionModalFooterRight">

                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default VehicleIncidentsChooseAction;
